import { BrowserProvider } from 'ethers';
import { getAppChainConfig } from './network';

let wcProvider = null;

export function isWalletConnectConfigured() {
  return Boolean(process.env.REACT_APP_WALLETCONNECT_PROJECT_ID);
}

export function isWalletConnectConnected() {
  return Boolean(wcProvider);
}

export function getWalletConnectEip1193Provider() {
  return wcProvider;
}

export async function disconnectWalletConnect() {
  try {
    if (wcProvider?.disconnect) {
      await wcProvider.disconnect();
    }
  } finally {
    wcProvider = null;
  }
}

export async function getWalletConnectProviderAndSigner() {
  if (!wcProvider) {
    throw new Error('WalletConnect not connected.');
  }
  const provider = new BrowserProvider(wcProvider);
  const signer = await provider.getSigner();
  return { provider, signer };
}

export async function connectWalletConnect() {
  const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;
  if (!projectId) {
    throw new Error('WalletConnect is not configured. Missing REACT_APP_WALLETCONNECT_PROJECT_ID.');
  }

  const cfg = getAppChainConfig();

  // Lazy import so we don't load WC code unless needed.
  const { default: EthereumProvider } = await import('@walletconnect/ethereum-provider');

  wcProvider = await EthereumProvider.init({
    projectId,
    chains: [cfg.chainId],
    showQrModal: true,
    rpcMap: {
      [cfg.chainId]: cfg.rpcUrl,
    },
    metadata: {
      name: 'IO Gaming Platform',
      description: 'Challenge your friends. Prove your skill. Earn rewards.',
      url: typeof window !== 'undefined' ? window.location.origin : 'https://example.com',
      icons: [],
    },
  });

  // Triggers QR modal / deep link.
  await wcProvider.enable();

  const provider = new BrowserProvider(wcProvider);
  const signer = await provider.getSigner();
  return { provider, signer };
}

